'use client';

import React from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import { PhoneIcon, EnvelopeIcon, FireIcon } from '@heroicons/react/24/outline';
import {
  getBranchData,
  getCurrentBranch,
  regionalizePath,
} from '@/lib/config/branches-config';
import { getLeadFormBranch } from '@/lib/forms/region';
import { useLanguage } from '@/lib/config/useLanguage';
import Region from './RegionOption';

export default function MobileRegionBar() {
  const pathname = usePathname() || '/';
  const { localizePath } = useLanguage();
  const currentBranchCode = getLeadFormBranch(pathname, useSearchParams().toString());
  const currentBranch = getBranchData(currentBranchCode) || getCurrentBranch();

  if (!currentBranch) {
    return null;
  }

  return (
    <div className="w-full border-b border-white/20 bg-header-gradient">
      <div className="site-container flex h-11 items-center justify-between sm:gap-4">
        {/* Левая часть - выбор города */}
        <div className="min-w-0 flex-1">
          <Region asButton={true} className="h-11 max-w-full text-sm font-medium text-white" />
        </div>

        <nav aria-label="Информация" className="flex shrink-0 items-center xl:gap-2">
          <a
            href={regionalizePath(localizePath('/sales/'), currentBranchCode)}
            aria-label="Акции"
            title="Акции"
            className="inline-flex h-11 w-8 items-center justify-center rounded-lg text-sm font-medium text-white transition-colors hover:bg-white/10 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white sm:w-10 xl:w-auto xl:px-2"
          >
            <FireIcon aria-hidden="true" className="size-5 shrink-0 xl:hidden" />
            <span className="hidden xl:inline">Акции</span>
          </a>
          <a
            href={regionalizePath(localizePath('/company/contacts/'), currentBranchCode)}
            aria-label="Контакты"
            title="Контакты"
            className="hidden h-11 items-center justify-center rounded-lg px-2 text-sm font-medium text-white transition-colors hover:bg-white/10 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white xl:inline-flex"
          >
            Контакты
          </a>
        </nav>

        {/* Правая часть - иконки контактов */}
        <div className="flex shrink-0 items-center xl:gap-3">
          {/* Телефон */}
          {currentBranch.phone && (
            <a
              href={`tel:${currentBranch.phone.replace(/[^+\d]/g, '')}`}
              className="group inline-flex h-11 w-8 items-center justify-center rounded-lg text-white transition-colors hover:bg-white/10 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white sm:w-10 xl:w-auto xl:gap-1.5 xl:px-2"
              aria-label="Телефон"
              title="Позвонить"
            >
              <PhoneIcon aria-hidden="true" className="size-5 shrink-0" />
              <span className="hidden text-sm font-medium text-white transition-colors group-hover:text-white/80 xl:inline">
                {currentBranch.phone}
              </span>
            </a>
          )}

          {/* Email */}
          {currentBranch.email && (
            <a
              href={`mailto:${currentBranch.email}`}
              className="group inline-flex h-11 w-8 items-center justify-center rounded-lg text-white transition-colors hover:bg-white/10 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white sm:w-10 xl:w-auto xl:gap-1.5 xl:px-2"
              aria-label="Email"
              title="Написать на e-mail"
            >
              <EnvelopeIcon aria-hidden="true" className="size-5 shrink-0" />
              <span className="hidden text-sm font-medium text-white transition-colors group-hover:text-white/80 xl:inline">
                {currentBranch.email}
              </span>
            </a>
          )}

          {/* Telegram */}
          {currentBranch.telegram && (
            <a
              href={currentBranch.telegram}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex h-11 w-8 items-center justify-center rounded-lg transition-colors hover:bg-white/10 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white sm:w-10"
              aria-label="Telegram"
              title="Telegram"
            >
              <img
                alt={'Telegram'}
                src="/icon/Telegram.svg"
                className="size-5 shrink-0 sm:size-6"
              />
            </a>
          )}

          <a
            href={
              'https://max.ru/u/f9LHodD0cOKkTKl7uHBoM9NKG6P5BepSPikVN6knzBtuCqb1-uy75Fth6c8'
            }
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex h-11 w-8 items-center justify-center rounded-lg transition-colors hover:bg-white/10 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white sm:w-10"
            aria-label="MAX"
            title="MAX"
          >
            <img
              alt={'max'}
              src="/icon/max.svg"
              className="size-5 shrink-0 sm:size-6"
            />
          </a>
        </div>
      </div>
    </div>
  );
}
